import { Stack, Typography, Link } from "@mui/material";
import React from "react";

const FileUploadCta = ({ ctaContent, buttonContent, buttonAction, testId }) => (
  <Stack
    direction="row"
    justifyContent="center"
    alignItems="center"
    mt={"18px"}
    gap={.5}
  >
    <Typography variant="subtitle2" data-testid={testId ? `${testId}-content` : undefined}>{ctaContent}</Typography>
    <Link
      data-testid={testId}
      component="button"
      variant="subtitle2"
      size="small"
      onClick={buttonAction}
    >
      {buttonContent}
    </Link>
  </Stack>
);

export default FileUploadCta;
